import React from "react";
import heroImg from "../../assets/policies/heroImg.webp";

const PrivacyPolicy = () => {
  return (
    <section
      data-aos="fade-up"
      data-aos-duration="1000"
      data-aos-once="true"
      className=" relative pt-24 md:pt-32 lg:pt-28 pb-4 md:pb-4 lg:pb-8 
                        px-4 md:px-8 lg:px-12 
                        bg-[#070021] text-white 
                        font-poppins tracking-widest"
    >
      {/* Left Blur  */}
      <div
        className="absolute left-0 top-0 w-[40%] h-[40%] rounded-full 
                           bg-[#1a99c03b] blur-[100px] md:blur-[140px] lg:blur-[180px] 
                           z-0"
      ></div>

      {/* Right Blur */}
      <div
        className="absolute right-0 top-0 w-[45%] h-[45%] rounded-full 
                     bg-[#1a99c03b] blur-[120px] md:blur-[160px] lg:blur-[200px] 
                     z-0"
      ></div>
      <div className="absolute top-0 -right-12 w-[40%]">
        <img
          src={heroImg}
          alt="Hero Background"
          className="inset-0 w-[100%] h-full object-cover "
          loading="eager"
          fetchpriority="high"
        />
      </div>
      <div className="max-w-[95%] mx-auto">
        <h1 className="text-3xl md:text-4xl lg:text-3xl font-semibold mb-8">
          Privacy Policy
        </h1>

        <div className="text-sm md:text-base lg:text-[14px] leading-relaxed mb-1">
          Updated On: <span className="text-[#49D093]">October 2023</span>
        </div>

        <div
          className="h-[0.8px] w-full mb-8 
                        bg-gradient-to-r from-[#49D093] via-[#38b87eef] to-[#0C226E]"
        />

        {/* Purpose */}
        <div data-aos="fade-up" data-aos-duration="1000" data-aos-once="true">
          <h2
            className="text-[14px] md:text-[16px] lg:text-[16px] 
                         font-medium mb-2 text-[#49D093]"
          >
            Purpose
          </h2>

          <p
            className="text-[10px] md:text-[12px] lg:text-[12px] 
                        font-extralight ml-2 mb-4 leading-relaxed"
          >
            Mark9 Pte Ltd (“Mark9 Solutions”, “we”, “our”, “us”) is committed to
            protecting your privacy.
            <br />
            This Policy explains how we collect, use, disclose, and safeguard
            personal information obtained through our websites, contact forms,
            and marketing activities.
          </p>
        </div>

        {/* Information We Collect */}
        <div
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-once="true"
          data-aos-delay="100"
          className="mt-5"
        >
          <h2
            className="text-[14px] md:text-[16px] lg:text-[16px] 
                         font-medium mb-2 text-[#49D093]"
          >
            Information We Collect
          </h2>

          <ul
            className="list-disc ml-4 md:ml-6 
                         text-[10px] md:text-[12px] lg:text-[12px] 
                         font-extralight space-y-1.5"
          >
            <li>
              Business contact details (name, email, phone, organization, role)
            </li>
            <li>
              Website usage data (IP address, browser type, pages visited,
              cookies)
            </li>
            <li>
              Any information voluntarily submitted (e.g., inquiries or event
              registrations)
            </li>
          </ul>
        </div>

        {/* How We Use Your Information */}
        <div
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-once="true"
          data-aos-delay="200"
          className="mt-5"
        >
          <h2
            className="text-[14px] md:text-[16px] lg:text-[16px] 
                         font-medium mb-2 text-[#49D093]"
          >
            How We Use Your Information
          </h2>

          <ul
            className="list-disc list-inside md:list-outside 
                         ml-2 md:ml-6 
                         text-[11px] md:text-[12px] lg:text-[12px] 
                         font-extralight space-y-1.5 text-white/90"
          >
            <li>
              To respond to inquiries and provide requested information or
              services
            </li>
            <li>To improve our website content and user experience</li>
            <li>To send updates about our offerings (if you opt in)</li>
            <li>To comply with legal or regulatory requirements</li>
          </ul>
        </div>

        {/* Data Sharing and Storage */}
        <div
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-once="true"
          data-aos-delay="300"
          className="mt-5"
        >
          <h2
            className="text-[14px] md:text-[16px] lg:text-[16px] 
                         font-medium mb-2 text-[#49D093]"
          >
            Data Sharing and Storage
          </h2>
          <p className="text-[10px] md:text-[12px] lg:text-[13px] font-extralight mb-2 ml-2 md:ml-2">
            We do not sell personal data. Information may be shared only with:
          </p>

          <ul
            className="list-disc list-inside md:list-outside 
                         ml-2 md:ml-6 
                         text-[11px] md:text-[12px] lg:text-[12px] 
                         font-extralight space-y-1.5 text-white/90"
          >
            <li>
              Our subsidiaries and trusted service providers under
              data-processing agreements.
            </li>
            <li>Regulators or law enforcement when required by law.</li>
            <li>
              Data may be transferred and stored securely on servers in
              Singapore and other jurisdictions where we operate.
            </li>
          </ul>
        </div>

        {/* Your Rights */}
        <div
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-once="true"
          data-aos-delay="400"
          className="mt-5"
        >
          <h2
            className="text-[14px] md:text-[16px] lg:text-[16px] 
                         font-medium mb-2 text-[#49D093]"
          >
            Your Rights
          </h2>

          <p className="text-[10px] md:text-[12px] lg:text-[13px] font-extralight mb-2 ml-2 md:ml-2">
            You may request access, correction, or deletion of your personal
            data, and withdraw consent at any time by contacting
            privacy@m9-solutions.com. <br /> We will respond in accordance with
            applicable privacy laws.
          </p>
        </div>

        {/* Cookies */}
        <div
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-once="true"
          data-aos-delay="500"
          className="mt-5"
        >
          <h2
            className="text-[14px] md:text-[16px] lg:text-[16px] 
                         font-medium mb-2 text-[#49D093]"
          >
            Cookies
          </h2>

          <p className="text-[10px] md:text-[12px] lg:text-[13px] font-extralight mb-2 ml-2 md:ml-2">
            We use cookies to analyze traffic and improve our site. You can
            adjust browser settings to decline cookies, though some features may
            be limited.
          </p>
        </div>

        {/* Security */}
        <div
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-once="true"
          data-aos-delay="600"
          className="mt-5"
        >
          <h2
            className="text-[14px] md:text-[16px] lg:text-[16px] 
                         font-medium mb-2 text-[#49D093]"
          >
            Security
          </h2>

          <p className="text-[10px] md:text-[12px] lg:text-[13px] font-extralight mb-2 ml-2 md:ml-2">
            We employ technical and organizational measures to protect data
            against loss, misuse, or unauthorized access.
          </p>
        </div>

        {/* Policy Updates */}
        <div
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-once="true"
          data-aos-delay="700"
          className="mt-5"
        >
          <h2
            className="text-[14px] md:text-[16px] lg:text-[16px] 
                         font-medium mb-2 text-[#49D093]"
          >
            Policy Updates
          </h2>

          <p className="text-[10px] md:text-[12px] lg:text-[13px] font-extralight mb-2 ml-2 md:ml-2">
            We may update this Privacy Policy periodically. The latest version
            will always be posted on our website.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
